"use client";
import React, { Fragment, useEffect, useState } from "react";
import { db } from "@/firebase";
import { doc, getDoc } from "firebase/firestore";

import dynamic from 'next/dynamic';
const Games = dynamic(() => import('@/components/games-page/games'), { ssr: false });
const GamesPageVideoBanner = dynamic(() => import('@/components/games-page/games-page-video-banner'), { ssr: false });

const HomePage = () => {
  const [webPlayDisplay, setWebPlayDisplay] = useState(false);

  useEffect(() => {
    const webplaySection = async () => {
      const docRef = doc(db, "data_params", "website");
      const docSnap = await getDoc(docRef);

      if (docSnap.exists()) {
        docSnap.data().display_webplay === true ? setWebPlayDisplay(true) : setWebPlayDisplay(false);
      } else {
        setWebPlayDisplay(false);
      }
    }

    webplaySection();
  }, [webPlayDisplay]);

  return (
    <Fragment>
      <GamesPageVideoBanner />

      <div className="!pr-6 !pl-6 xl:container mt-8">
        <Games osTypes={["ios", "android"]} />
        <Games osTypes={["pc"]} />
        {webPlayDisplay === true ? (
          <Games osTypes={["web"]} />
        ) : null}
      </div>
    </Fragment>
  );
};

export default HomePage;
